import { mediaBoxApi } from '@/axios/mediaBox';
import CustomSelect from '@/components/Base/Select';
import { useRequest } from 'ahooks';
import { Space } from 'antd';
import { useState, type CSSProperties } from 'react';
import MediaBoxSelector from '../MediaBoxSelector';
import styles from './index.module.less';

interface ChannelMediaBoxSelectorProps {
  value?: string;
  onChange?: (value: string) => void;
  defaultOptions?: Array<{ label: string; value: string }>;
  style?: CSSProperties;
}

const ChannelMediaBoxSelector = ({ value, onChange, defaultOptions, style }: ChannelMediaBoxSelectorProps) => {
  const [channel, setChannel] = useState<string>();
  const { data: channels = [], loading } = useRequest(() => mediaBoxApi.channels(), {
    cacheKey: 'media-box-channels',
  });

  return (
    <Space.Compact block className={styles.selectorGroup} style={style}>
      <CustomSelect
        allowClear
        className={styles.channelSelect}
        loading={loading}
        options={channels.map((item) => ({
          label: item.name,
          value: item.code,
        }))}
        placeholder="请选择渠道"
        style={{ width: '34%' }}
        value={channel}
        onChange={(nextChannel) => {
          setChannel(nextChannel);
          onChange?.('');
        }}
      />
      <MediaBoxSelector
        key={channel || 'all-media'}
        params={{
          statuses: [1],
          // 最低价为包含边界，按金额精度从 0.1 元起排除零价媒体。
          minPrice: 1,
          ...(channel ? { channels: [channel] } : {}),
        }}
        defaultOptions={channel ? [] : defaultOptions}
        placeholder="请选择媒体"
        style={{ width: '66%' }}
        popupMatchSelectWidth
        classNames={{ popup: { root: styles.mediaPopup } }}
        placement="bottomRight"
        listHeight={220}
        endReachedContent={<div className={styles.endReached}>到底啦，我们都到齐啦～～</div>}
        value={value}
        onChange={onChange}
      />
    </Space.Compact>
  );
};

export default ChannelMediaBoxSelector;
